/**
 * newsletterForm — Brevo signup form.
 *
 * Submits via fetch to the Craft endpoint (modules/site/controllers/NewsletterController.php)
 * and shows an inline success or error message instead of a full page reload.
 *
 * Twig markup: templates/_blocks/newsletterblock.twig
 */
export default function Newsletterform() {
  Alpine.data("newsletterForm", () => ({
    name: "",
    email: "",
    website: "", // honeypot, left empty by real visitors
    loading: false,
    status: null, // null | 'success' | 'error'
    message: "",

    async submit() {
      if (this.loading) return;

      this.status = null;
      this.message = "";
      this.loading = true;

      const form = this.$el;

      try {
        const response = await fetch(form.action, {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form),
        });

        const data = await response.json().catch(() => null);

        if (response.ok && data?.success) {
          this.status = "success";
          this.message = data.message || "Tak for din tilmelding!";
          form.reset();
          this.name = "";
          this.email = "";
        } else {
          this.status = "error";
          this.message = data?.message || "Der gik noget galt. Prøv igen om lidt.";
        }
      } catch (e) {
        this.status = "error";
        this.message = "Der gik noget galt. Tjek din internetforbindelse og prøv igen.";
      } finally {
        this.loading = false;
      }
    },
  }));
}
